import {
  RESET_SKILLS,
  RESET_SKILL,
  RESET_ERROR,
  GET_SKILLS,
  SET_SKILLS,
  API_ERROR,
  GET_SKILL,
  SET_SKILL,
  CREATE_SKILL,
  CREATE_SKILL_SUCCESS,
  EDIT_SKILL,
  EDIT_SKILL_SUCCESS,
  DELETE_SKILL,
  DELETE_SKILL_SUCCESS,
} from "./actionTypes";

export const resetSkills = () => {
  return {
    type: RESET_SKILLS,
    payload: {},
  };
};

export const resetSkill = () => {
  return {
    type: RESET_SKILL,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getSkills = (page, qnt, name) => {
  return {
    type: GET_SKILLS,
    payload: { page, qnt, name },
  };
};

export const setSkills = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_SKILLS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createSkill = (newSkillValues) => {
  return {
    type: CREATE_SKILL,
    payload: { newSkillValues },
  };
};
export const createSkillSuccess = (message) => {
  return {
    type: CREATE_SKILL_SUCCESS,
    payload: { message },
  };
};

export const getSkill = (idSkill, isForm) => {
  return {
    type: GET_SKILL,
    payload: { idSkill, isForm },
  };
};
export const setSkill = (data) => {
  return {
    type: SET_SKILL,
    payload: { data },
  };
};

export const editSkill = (idSkill, newSkillValues) => {
  return {
    type: EDIT_SKILL,
    payload: { idSkill, newSkillValues },
  };
};
export const editSkillSuccess = (message) => {
  return {
    type: EDIT_SKILL_SUCCESS,
    payload: { message },
  };
};

export const deleteSkill = (idSkill) => {
  return {
    type: DELETE_SKILL,
    payload: { idSkill },
  };
};
export const deleteSkillSuccess = (message) => {
  return {
    type: DELETE_SKILL_SUCCESS,
    payload: { message },
  };
};
